import { connect } from 'react-redux';

import {
  actionGetProvinceList,
  actionGetDistrictList,
  actionGetWardList,
} from 'store/address/actions';
import { actionAddLocationByStep, actionChangeTab } from 'store/edit-location/actions';
import { actionOpenModal } from 'store/global/modal/actions';
import { CREATE_NEW_PLACE } from 'store/place/actionTypes';
import { actionUploadContract } from 'store/media/actions';

import EditLocation from './EditLocation';

const mapStateToProps = (state) => ({
  isLoadingCreateNewPlace: state.Place.isLoadingCreateNewPlace,
  isLoadingLocationList: state.Location.loadingLocationList,
  loadingUploadContract: state.Media.loadingUploadContract,

  me: state.Profile.me,
  provinces: state.Address.provinces,
  districts: state.Address.districts,
  wards: state.Address.wards,

  step: state.EditLocation.step,
  stepAvailable: state.EditLocation.stepAvailable,
  location: state.EditLocation.location,
  setting: state.Setting.setting,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetProvinceList: (payload) => dispatch(actionGetProvinceList(payload)),
  actionGetDistrictList: (payload) => dispatch(actionGetDistrictList(payload)),
  actionGetWardList: (payload) => dispatch(actionGetWardList(payload)),
  actionAddLocationByStep: (payload) => dispatch(actionAddLocationByStep(payload)),
  actionChangeTab: (payload) => dispatch(actionChangeTab(payload)),
  actionOpenModalCreatePlaceSuccess: (payload) => dispatch(actionOpenModal(payload)),
  actionCreateNewPlace: (payload) => dispatch({ type: CREATE_NEW_PLACE, payload }),
  actionUploadContract: (payload) => dispatch(actionUploadContract(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditLocation);
